import { OrientedBoundingBox } from "@/components/r3f/utils/oriented-bounding-box";
import { RootState } from "./store";

/** @returns the clipping box saved in the store */
export function selectClippingBox({
  clippingBox,
}: RootState): OrientedBoundingBox | undefined {
  return clippingBox.clippingBox;
}
